import { render, staticRenderFns } from "./ModalGruposPermissoes.vue?vue&type=template&id=513ca0f3&"
import script from "./ModalGruposPermissoes.vue?vue&type=script&lang=js&"
export * from "./ModalGruposPermissoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports